export var EmailTemplate;
(function (EmailTemplate) {
    EmailTemplate["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
    EmailTemplate["TRANSACTION_CONFIRMATION"] = "TRANSACTION_CONFIRMATION";
    EmailTemplate["SECURITY_ALERT"] = "SECURITY_ALERT";
    EmailTemplate["KYC_STATUS_UPDATE"] = "KYC_STATUS_UPDATE";
    EmailTemplate["ACCOUNT_DELETION_REQUEST"] = "ACCOUNT_DELETION_REQUEST";
    EmailTemplate["ACCOUNT_DELETION_ADMIN"] = "ACCOUNT_DELETION_ADMIN";
    EmailTemplate["STANDING_ORDER_GENERATION_REPORT"] = "STANDING_ORDER_GENERATION_REPORT";
    EmailTemplate["SUBSCRIPTION_BILLING_REPORT"] = "SUBSCRIPTION_BILLING_REPORT";
    EmailTemplate["DOCUMENT_DELIVERY"] = "DOCUMENT_DELIVERY";
    EmailTemplate["WITHDRAWAL_RECEIVED"] = "WITHDRAWAL_RECEIVED";
    EmailTemplate["WITHDRAWAL_ADMIN"] = "WITHDRAWAL_ADMIN";
    EmailTemplate["TRADEVEST_CANCELLATION_RECEIVED"] = "TRADEVEST_CANCELLATION_RECEIVED";
    EmailTemplate["TRADEVEST_CANCELLATION_ADMIN"] = "TRADEVEST_CANCELLATION_ADMIN";
    EmailTemplate["TRADEVEST_ORDER_EXECUTED"] = "TRADEVEST_ORDER_EXECUTED";
    EmailTemplate["TRADEVEST_ORDER_FAILED"] = "TRADEVEST_ORDER_FAILED";
    EmailTemplate["TRADEVEST_ORDER_PLACED"] = "TRADEVEST_ORDER_PLACED";
    EmailTemplate["KYC_MANUAL_REVIEW_ADMIN"] = "KYC_MANUAL_REVIEW_ADMIN";
    EmailTemplate["EMAIL_ADDRESS_CHANGED"] = "EMAIL_ADDRESS_CHANGED";
    EmailTemplate["PAYCENTER_TRANSFER_NOT_ALLOWED_ADMIN"] = "PAYCENTER_TRANSFER_NOT_ALLOWED_ADMIN";
    EmailTemplate["PAYCENTER_REGISTRATION_STUCK_ADMIN"] = "PAYCENTER_REGISTRATION_STUCK_ADMIN";
})(EmailTemplate || (EmailTemplate = {}));
//# sourceMappingURL=email.types.js.map